import { Toaster } from "react-hot-toast";

export default function AppToaster() {
  return <Toaster containerStyle={{ zIndex: 9999999999 }} />;
}
